document.addEventListener("DOMContentLoaded", function () {
	// Select all headers and bodies
	const allHeaders = document.querySelectorAll(".day-header");
	const allBodies = document.querySelectorAll(".day-body");

	// --- Initial State Setup ---
	// Ensure all are closed by default (redundant if HTML/CSS defaults are correct, but safe)
	allHeaders.forEach((h) => h.classList.remove("expanded"));
	allBodies.forEach((b) => b.classList.add("hidden"));

	// Open the very first one, if it exists
	const firstHeader = document.querySelector(
		".day-schedule .day .day-header"
	); // Use a more specific selector if needed
	const firstBody = document.querySelector(".day-schedule .day .day-body"); // Use a more specific selector if needed

	if (firstHeader && firstBody) {
		firstHeader.classList.add("expanded");
		firstBody.classList.remove("hidden");
	}

	// --- Click Event Listeners ---
	allHeaders.forEach((header) => {
		header.addEventListener("click", () => {
			// Find the corresponding body (assuming it's the next sibling)
			const body = header.nextElementSibling;
			// Safety check: ensure the next sibling is actually the body we expect
			if (!body || !body.classList.contains("day-body")) {
				console.warn(
					"Could not find corresponding .day-body for clicked header."
				);
				return;
			}

			const isCurrentlyExpanded = header.classList.contains("expanded");

			// Collapse all headers and bodies first
			allHeaders.forEach((h) => h.classList.remove("expanded"));
			allBodies.forEach((b) => b.classList.add("hidden"));

			// If the clicked item was NOT already expanded, then expand it.
			// (If it was already expanded, clicking it again will just leave it closed from the step above)
			if (!isCurrentlyExpanded) {
				header.classList.add("expanded");
				body.classList.remove("hidden");
			}
		});
	});
});
